import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Materials from "./pages/Materials";
import Quote from "./pages/Quote";
import Portfolio from "./pages/Portfolio";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import KVKK from "./pages/KVKK";
import Terms from "./pages/Terms";
import { PublicDataProvider } from "./hooks/usePublicData";
import { AdminAuthProvider, RequireAdmin } from "./admin/AdminAuth";
import AdminSection from "./admin/AdminSection";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminQuotes from "./admin/AdminQuotes";
import AdminMessages from "./admin/AdminMessages";
import AdminSettings from "./admin/AdminSettings";
import AdminPricing from "./admin/AdminPricing";
import AdminServices from "./admin/AdminServices";
import AdminMaterials from "./admin/AdminMaterials";
import AdminPortfolio from "./admin/AdminPortfolio";
import AdminFAQs from "./admin/AdminFAQs";
import AdminChangePassword from "./admin/AdminChangePassword";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <PublicDataProvider>
            <Routes>
              {/* Admin: html.dark AdminSection ile sabitlenir; public tema Layout’ta */}
              <Route path="/dekosta-yonetim" element={<AdminSection />}>
                <Route path="login" element={<AdminLogin />} />
                <Route element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="teklifler" element={<AdminQuotes />} />
                  <Route path="mesajlar" element={<AdminMessages />} />
                  <Route path="ayarlar" element={<AdminSettings />} />
                  <Route path="fiyatlandirma" element={<AdminPricing />} />
                  <Route path="hizmetler" element={<AdminServices />} />
                  <Route path="malzemeler" element={<AdminMaterials />} />
                  <Route path="portfoy" element={<AdminPortfolio />} />
                  <Route path="faq" element={<AdminFAQs />} />
                  <Route path="sifre" element={<AdminChangePassword />} />
                </Route>
              </Route>
              <Route path="/forma-yonetim/login" element={<Navigate to="/dekosta-yonetim/login" replace />} />
              <Route path="/forma-yonetim/*" element={<Navigate to="/dekosta-yonetim" replace />} />

              {/* Public routes */}
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/hizmetler" element={<Services />} />
                <Route path="/malzemeler" element={<Materials />} />
                <Route path="/teklif-al" element={<Quote />} />
                <Route path="/portfoy" element={<Portfolio />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/gizlilik" element={<Privacy />} />
                <Route path="/kvkk" element={<KVKK />} />
                <Route path="/kullanim-sartlari" element={<Terms />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </PublicDataProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
